import { NgOptimizedImage } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'
import { ReasonTimePipe } from '../../../pipes/reason-time.pipe'
import {
    BookingPaymentTerminology,
    bookingPaymentTerminologyForVenueId,
} from '../../../domain/BookingPaymentTerminology'
import { environment } from '../../../../environments/environment'
import { richTextPlainText } from '../../../utilities/rich-text'
import { QuillModule } from 'ngx-quill'
import type { VenueStorefrontBookingChoice } from '../venue-storefront-booking-flow/venue-storefront-booking-flow.types'

@Component({
    selector: 'app-venue-storefront-booking-choice-row',
    standalone: true,
    imports: [NgOptimizedImage, ReasonTimePipe, QuillModule],
    templateUrl: './venue-storefront-booking-choice-row.component.html',
    styleUrls: ['./venue-storefront-booking-choice-row.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VenueStorefrontBookingChoiceRowComponent {
    choice = input.required<VenueStorefrontBookingChoice>()
    gridLayout = input(false)
    date = input.required<Date>()
    paymentTerminology = input<BookingPaymentTerminology>(
        bookingPaymentTerminologyForVenueId()
    )
    choiceSelected = output<VenueStorefrontBookingChoice>()

    protected readonly displayName = computed(() => {
        const choice = this.choice()
        if (choice.kind === 'standard') return 'Standard Booking'
        return choice.kind === 'event'
            ? choice.event.displayName
            : choice.reason.displayName
    })
    protected readonly description = computed(() => {
        const choice = this.choice()
        const description = choice.kind === 'event'
            ? choice.event.description
            : choice.kind === 'reason' ? choice.reason.description : null
        return richTextPlainText(description) ? description : null
    })
    protected readonly imageUrl = computed(() => {
        const choice = this.choice()
        if (choice.kind === 'standard') return null
        const imageId = choice.kind === 'event' ? choice.event.imageId : choice.reason.imageId
        const directory = choice.kind === 'event' ? 'event-images' : 'reason-images'
        const size = this.gridLayout() ? '700x400' : '192x192'
        return imageId
            ? `${environment.cdnUrl}/${size}/${directory}/${imageId}`
            : null
    })
    protected readonly reasonChoice = computed(() => {
        const choice = this.choice()
        return choice.kind === 'reason' ? choice : null
    })
}
